export enum FolderOperationType {
  EDIT = 'EDIT',
  UNDO_DELETE = 'UNDO_DELETE',
  DELETE = 'DELETE',
  CREATE = 'CREATE',
}
